import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.99996 18.7751C14.6023 18.7751 18.3333 15.0441 18.3333 10.4417C18.3333 5.83936 14.6023 2.1084 9.99996 2.1084C5.39759 2.1084 1.66663 5.83936 1.66663 10.4417C1.66663 15.0441 5.39759 18.7751 9.99996 18.7751Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.91663 7.91284C7.91663 7.51511 7.91663 7.31624 7.99974 7.20521C8.07218 7.10846 8.18305 7.04793 8.30361 7.03932C8.44195 7.02944 8.60923 7.13698 8.9438 7.35206L12.8776 9.88095C13.1679 10.0676 13.3131 10.1609 13.3632 10.2796C13.4071 10.3832 13.4071 10.5002 13.3632 10.6039C13.3131 10.7226 13.1679 10.8159 12.8776 11.0025L8.9438 13.5314C8.60923 13.7465 8.44195 13.854 8.30361 13.8441C8.18305 13.8355 8.07218 13.775 7.99974 13.6783C7.91663 13.5672 7.91663 13.3684 7.91663 12.9706V7.91284Z",
      stroke: "#23252C",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }